// extracted by mini-css-extract-plugin
module.exports = {"container":"form_container__KqIfG","title":"form_title__2YEIT","btn":"form_btn__2fZvU","dropdownStyle":"form_dropdownStyle__13slh"};